import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TopBar } from '../../components/top_bar/TopBar';
import { Helmet } from 'react-helmet';
import posthog from 'posthog-js';
import './ThankYou.css';

const ThankYou = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const jobId = searchParams.get('job');
    const TITLE = 'Thank You - Mirwork';

    useEffect(() => {
        posthog.capture('$pageview', {
            $current_url: window.location.href,
            $host: window.location.hostname,
            $pathname: window.location.pathname,
        });
    }, []);

    const handleHomeClick = () => {
        navigate('/');
    };

    return (
        <>
            <Helmet>
                <title>{TITLE}</title>
            </Helmet>
            <TopBar />
            <Box className="thank-you-container">
                <Box className="thank-you-content">
                    <Typography className="title-text-thin" style={{ marginBottom: '15px' }}>
                        Thank You for Completing the Interview!
                    </Typography>
                    <Typography className="small-grey-text" style={{ marginBottom: '30px', width: '60%', textAlign: 'center' }}>
                        Your interview has been successfully submitted. The hiring team will review your responses and get back to you soon.
                    </Typography>
                    <Button 
                        variant="contained" 
                        onClick={handleHomeClick}
                        className="main-button-middle"
                    >
                        Return to Home
                    </Button>
                </Box>
            </Box>
        </>
    );
};

export default ThankYou; 